import { Component } from '@angular/core';

@Component({
  selector: 'app-minton',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {}
